/* The trip in the address bar (Oct 2026, mock Fix_A change 10). Cars (Home) and Drivers
   write what is set - From, To, round trip or drop, the date and time, the return, stops
   and the language - into the address as it changes, and read it back when a link is
   opened. So an agent can set "Vijayawada → Ongole, tomorrow 10 am" and send the link
   (or tap Share list): the customer opens the same list, already filled, and scrolls.

   Only the words go in - the place names as picked, never coordinates or anything about
   the person; distances are worked out again from the names, as for a typed trip. */

const TRIP_WORD = { ROUND: "round", ONE_WAY: "drop", LOCAL: "local" };
const WORD_TRIP = Object.fromEntries(Object.entries(TRIP_WORD).map(([k, v]) => [v, k]));
const LANGS = ["en", "te", "hi", "ta", "kn"];

const text = (loc) => String((loc && typeof loc === "object" ? loc.value : loc) || "").trim();

/** "?from=…&to=…&trip=round&on=…&back=…&via=…&lang=te" for what is set ("" when nothing is). */
export function tripQuery({ from, to, tripType, on, back, stops, lang, keepBack = false }) {
  const q = new URLSearchParams();
  if (text(from)) q.set("from", text(from));
  if (text(to)) q.set("to", text(to));
  if (text(from) || text(to)) {
    if (TRIP_WORD[tripType]) q.set("trip", TRIP_WORD[tripType]);
    if (on) q.set("on", on);
    // A cab drop has no return; a hire driver's one-way trip still has an end time.
    if (back && (keepBack || tripType !== "ONE_WAY")) q.set("back", back);
    for (const s of stops || []) if (text(s)) q.append("via", text(s));
  }
  if (lang && lang !== "en" && LANGS.includes(lang)) q.set("lang", lang);
  const s = q.toString();
  return s ? `?${s}` : "";
}

/** What a link carries, or null when it carries no trip and no language. */
export function readTripQuery(search) {
  const q = new URLSearchParams(search || "");
  const place = (k) => { const v = (q.get(k) || "").trim().slice(0, 200); return v ? { value: v, selected: true } : null; };
  const out = {
    from: place("from"), to: place("to"),
    tripType: WORD_TRIP[q.get("trip")] || null,
    on: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(q.get("on") || "") ? q.get("on") : null,
    back: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(q.get("back") || "") ? q.get("back") : null,
    stops: q.getAll("via").map((v) => v.trim().slice(0, 200)).filter(Boolean).slice(0, 5).map((v) => ({ value: v, selected: true })),
    lang: LANGS.includes(q.get("lang")) ? q.get("lang") : null,
  };
  return out.from || out.to || out.lang ? out : null;
}

/** Puts the query in the address without a new history step, keeping the router's own state. */
export function syncTripUrl(query) {
  if (typeof window === "undefined") return;
  const url = `${window.location.pathname}${query}${window.location.hash}`;
  if (url !== `${window.location.pathname}${window.location.search}${window.location.hash}`) {
    window.history.replaceState(window.history.state, "", url);
  }
}

/** The phone's share sheet where there is one; otherwise the link is copied. "shared" | "copied" | null. */
export async function shareTripLink({ title }) {
  const url = window.location.href;
  try {
    if (navigator.share) { await navigator.share({ title, url }); return "shared"; }
  } catch (err) {
    if (err?.name === "AbortError") return null;
  }
  try { await navigator.clipboard.writeText(url); return "copied"; } catch { return null; }
}
